const RATES = [0, 12, 21];

export function VatRatePicker({ value, onChange, vatPayer = true, testid = "vat-rate" }) {
    if (!vatPayer) {
        return (
            <div data-testid={`${testid}-nonpayer`}>
                <label className="label-eyebrow block mb-1.5">DPH</label>
                <div className="px-3 py-2 border border-dashed border-slate-300 bg-slate-50 text-xs text-slate-600 rounded-sm">
                    Neplátce DPH — doklad se vystaví bez DPH (0 %). Změnit lze v Nastavení firmy.
                </div>
            </div>
        );
    }
    const num = Number(value);
    const isPreset = RATES.includes(num);
    return (
        <div>
            <label className="label-eyebrow block mb-1.5">Sazba DPH</label>
            <div className="flex items-stretch gap-1.5">
                {RATES.map((r) => (
                    <button key={r} type="button" onClick={() => onChange(r)} data-testid={`${testid}-${r}`}
                            className={`px-3 py-2 text-xs font-bold tabular-data border rounded-sm transition-colors ${num === r ? "bg-slate-900 text-white border-slate-900" : "border-slate-300 text-slate-700 hover:bg-slate-50"}`}>
                        {r} %
                    </button>
                ))}
                <input type="number" step="0.1" min="0" max="100" value={isPreset ? "" : (value ?? "")} placeholder="jiná"
                       onChange={(e) => onChange(e.target.value)} data-testid={`${testid}-custom`}
                       className={`w-16 px-2 py-2 border text-xs text-right rounded-sm focus:outline-none focus:ring-2 focus:ring-orange-600 ${!isPreset ? "border-slate-900" : "border-slate-300"}`} />
            </div>
        </div>
    );
}
